import type { Authenticator } from "@firecms/core";
import type { FirebaseUserWrapper } from "@firecms/firebase";

export const adminAuthenticator: Authenticator<FirebaseUserWrapper> = async ({
  user,
  authController
}) => {
  if (!user?.firebaseUser) {
    return false;
  }

  const idTokenResult = await user.firebaseUser.getIdTokenResult(true);
  const isAdmin = idTokenResult.claims.admin === true;

  authController.setExtra({
    admin: isAdmin,
    email: user.email ?? null
  });

  if (!isAdmin) {
    throw new Error("This Firebase account is not authorized for Frienzzi Admin.");
  }

  return true;
};
